import React, { useContext } from 'react';
import { Grid, Stack, CircularProgress } from '@mui/material';
import { useSelector } from 'react-redux';
import { useMutation } from '@apollo/client';
import { useBPFMutations } from 'modules/stages';
import { CommonDataContext } from 'contexts/CommonDataContext';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import { portalConfigurationsSelectors } from 'redux/portalConfigurationReducer';
import { PortalConfigurationType, VendorProfile } from '@trnsact/trnsact-shared-types';
import { RenderWithFallback } from 'components/shared/Conditional/RenderWithFallback';

import { getConfigToSaveDealer, getConfigToSaveLender } from '../lib';
import { PortalConfiguration, PortalConfigurationRenderProps } from '../../types';
import {
  PortalConfigDealer,
  PortalConfigLender,
  PortalManagementFormValuesDealer,
  PortalManagementFormValuesLender,
} from '../types';
import { portalManagementApi } from '../api';
import { PortalManagementFormDealer } from './PortalManagementFormDealer';
import { PortalManagementFormLender } from './PortalManagementFormLender';

export const PortalManagement = ({ loading, onSaveConfiguration }: PortalConfigurationRenderProps) => {
  const { isLenderUser, isDealerUser } = useContext(CommonDataContext);
  const { handleSetDefaultsForAccount } = useBPFMutations();

  const vendorProfile = useSelector((state: any) => state.vp) as VendorProfile;

  const portalConfiguration = useSelector((state: any) =>
    portalConfigurationsSelectors.configDataByType(state, PortalConfigurationType.Portal)
  ) as PortalConfiguration<PortalConfigDealer | PortalConfigLender>;

  const [updateVendorProfile] = useMutation(portalManagementApi.updateVendorProfile);

  const handleSave = async (formData: PortalManagementFormValuesDealer | PortalManagementFormValuesLender) => {
    debugger;
    try {
      const config = isLenderUser
        ? getConfigToSaveLender(formData as PortalManagementFormValuesLender)
        : getConfigToSaveDealer(formData as PortalManagementFormValuesDealer);

      await onSaveConfiguration({ ...portalConfiguration, jsonDefinition: { config } });

      await updateVendorProfile({
        variables: {
          entityId: vendorProfile.id,
          fieldsObj: {
            multiLocationManagement: formData.multiLocationManagement,
          },
        },
      });

      if (config.enhancedStagesFlow) await handleSetDefaultsForAccount();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Grid item sm={12} md={6}>
      <CardContainer title="Portal">
        <RenderWithFallback
          isLoading={!portalConfiguration || !vendorProfile}
          fallBack={
            <Stack alignItems="center" justifyContent="center" height="100%">
              <CircularProgress />
            </Stack>
          }
        >
          {isDealerUser && (
            <PortalManagementFormDealer
              isLoading={loading}
              onConfirm={handleSave}
              vendorProfile={vendorProfile}
              portalConfigurationConfig={portalConfiguration?.jsonDefinition?.config}
            />
          )}

          {isLenderUser && (
            <PortalManagementFormLender
              isLoading={loading}
              onConfirm={handleSave}
              vendorProfile={vendorProfile}
              portalConfigurationConfig={portalConfiguration?.jsonDefinition?.config}
            />
          )}
        </RenderWithFallback>
      </CardContainer>
    </Grid>
  );
};
